<template>
  <NodePage v-if="node" v-bind="node" />
</template>

<script lang="ts" setup>
defineOptions({
  name: 'PageSlug',
})

definePageMeta({
  name: 'drupal-route',
  path: '/:slug(.*)*',
})

// Handles redirects and metatags.
const { entity: node } = await useDrupalRouteQuery('slug')

await renderPageDependencies()
</script>
